<template>
  <b-modal
    id="topic-modal"
    centered
    ref="topicModal"
    title="Enter Topic"
    @ok="handleOk"
    :ok-disabled="!topicInput.trim()"
  >
    <div>
      <label for="topic-input">Please enter a topic to continue:</label>
      <b-form-input
        id="topic-input"
        v-model="topicInput"
        placeholder="Enter topic here"
        autofocus
      ></b-form-input>
    </div>
  </b-modal>
</template>

<script>
import DataSettings from "@/helpers/DataSettings";
export default {
  name: "TopicModal",
  data() {
    return {
      topicInput: "",
    };
  },
  methods: {
    show(initialValue = "") {
      this.topicInput = initialValue;
      this.$refs.topicModal.show();
    },
    hide() {
      this.$refs.topicModal.hide();
    },
    handleOk() {
      DataSettings.setSettings("filters.topic", this.topicInput.trim());
      this.hide();
    },
  },
};
</script>
